import React, { useContext } from "react";
// import PubSub from "pubsub-js";
import SlickSlider from "react-slick";
// import SlideImage from "./SlideImage";
import Image from "./Image";
import { WrapperContext } from "../Layout";

const Slider = ({ input }) => {
  const { isMobile } = useContext(WrapperContext);
  // const [current, setCurrent] = useState(1);
  // const [length, setLength] = useState(input.length || 0);
  // const [isMobile, setIsMobile] = useState(undefined);

  // const sliderRef = useRef();

  // useEffect(() => {
  //   // document.addEventListener("keydown", _onKey);
  // }, []);

  const _onKey = e => {
    console.log(e.keyCode);
    // switch (e.keyCode) {
    //   case 37:
    //     sliderRef.current.slickPrev();
    //     break;
    //   case 39:
    //     sliderRef.current.slickNext();
    //     break;
    // }
  };
  // const _onEdge = () => {};
  // const _sliderBeforeChange = (oldIndex, newIndex) => {};
  // const _sliderAfterChange = index => {
  //   const activeSlide = document.querySelector(
  //     `.slick-current[data-index='${index}']`
  //   );
  //   // console.log(activeSlide);
  //   if (activeSlide)
  //     PubSub.publish("SLIDER_CHANGE", {
  //       current: activeSlide
  //       // length: length
  //     });
  // };

  const settings = {
    fade: !isMobile,
    dots: false,
    speed: isMobile ? 400 : 10,
    swipe: isMobile
    // variableWidth: true,
    // initialSlide: startAt,
    // lazyLoad: true,
    // beforeChange: _sliderBeforeChange,
    // afterChange: _sliderAfterChange
    // onEdge: _onEdge,
  };
  // console.log(input);
  return (
    <div className={"slider"}>
      <SlickSlider {...settings}>
        {input.map((el, i) => (
          <div
            className='slide'
            key={i}
            data-ratio={el.image.asset.metadata.dimensions.aspectRatio}>
            <Image input={el.image} />
            {/* <pre>{JSON.stringify(el)}</pre> */}
          </div>
        ))}
      </SlickSlider>
    </div>
  );
};

export default Slider;
